import { requestGet, requestPost, requestPut } from '../util/request';

export interface MemberActivityItem {
  activityId: string | number;
  name: string;
  description: string | null;
  rewardAmount: number;
  rewardDropsType: string;
  taskType: string;
  completionCondition: string;
  claimMethod: string;
  redirectLink: string;
}

export interface MemberActivitiesResponse {
  success: boolean;
  code: number;
  data: MemberActivityItem[];
}

export const getMemberActivities = async (): Promise<MemberActivitiesResponse | null> => {
  try {
    // setupProxy 已经把 /krene-backend-ts 转发到后端
    const res = await requestGet(`${ process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/activities`, true);
    return res as MemberActivitiesResponse | null;
  } catch (e) {
    return null;
  }
};

export interface ClaimDailyRewardResponseData {
  activityId: string | number;
  activityName: string;
  rewardAmount: number;
  rewardDropsType: string;
  claimedAt: string;
}

export interface ClaimDailyRewardResponse {
  success: boolean;
  code: number;
  data: ClaimDailyRewardResponseData;
  message?: string;
}

export const claimDailyReward = async (activityId: string | number): Promise<ClaimDailyRewardResponse | null> => {

  const payload = { activityId };
  try {
    return (await requestPost(`${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/claim-daily-reward`, payload, true)) as
      | ClaimDailyRewardResponse
      | null;
  } catch {
    return null;
  }
};

export interface ClaimFollowRewardResponse {
  success: boolean;
  code: number;
  data?: {
    activityId?: string | number;
    activityName?: string;
    rewardAmount?: number;
    rewardDropsType?: string;
    claimedAt?: string;
  } | null;
  message?: string;
}

export const claimFollowReward = async (activityId: string | number): Promise<ClaimFollowRewardResponse | null> => {
  const payload = { activityId };
  try {
    return (await requestPost(
      `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/claim-follow-reward`,
      payload,
      true,
    )) as ClaimFollowRewardResponse | null;
  } catch {
    return null;
  }
};

export interface ActivityApplicationPayload {
  type: 'by_screenshot' | 'by_id';
  content: Record<string, string>;
  deviceId?: string;
}

export interface ActivityApplicationResponse {
  success: boolean;
  code?: number;
  message?: string;
  data?: unknown;
}

export interface UpdateActivityApplicationPayload {
  id: string | number;
  type: 'by_screenshot' | 'by_id';
  content: Record<string, string>;
}

export interface UpdateActivityApplicationResponse {
  success: boolean;
  code: number;
  data?: { id: string | number } | null;
  message?: string;
}

export const updateActivityApplication = async (
  payload: UpdateActivityApplicationPayload,
): Promise<UpdateActivityApplicationResponse | null> => {
  try {
    return (await requestPut(
      `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/activity-applications`,
      payload,
      true,
    )) as UpdateActivityApplicationResponse | null;
  } catch {
    return null;
  }
};

export const createActivityApplication = async (
  payload: ActivityApplicationPayload,
): Promise<ActivityApplicationResponse | null> => {
  try {
    return (await requestPost(
      `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/activity-applications`,
      payload,
      true,
    )) as ActivityApplicationResponse | null;
  } catch {
    return null;
  }
};

export interface ActivityApplicationItem {
  id: string | number;
  userId?: string;
  deviceId?: string;
  ip?: string;
  status: string;
  type?: string;
  content?: any;
  comment?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface ActivityApplicationsResponse {
  success: boolean;
  code: number;
  data?:
    | ActivityApplicationItem[]
    | { items?: ActivityApplicationItem[]; total?: number; page?: number; pageSize?: number };
}

export const getActivityApplications = async (
  page = 1,
  pageSize = 10,
): Promise<ActivityApplicationsResponse | null> => {
  try {
    return (await requestGet(
      `${process.env.REACT_APP_APPLICATION_MAIN_INTERFACE}/api/member/activity-applications?page=${page}&pageSize=${pageSize}`,
      true,
    )) as ActivityApplicationsResponse | null;
  } catch {
    return null;
  }
};

